import { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "@clerk/react";
import { API } from "@/lib/api";

const InfoCtx = createContext(null);

export function InfoProvider({ children }) {
  const [info, setInfo] = useState(null);
  const [error, setError] = useState(false);
  const [me, setMe] = useState(null);
  const [meStatus, setMeStatus] = useState("idle");
  const { isSignedIn, getToken, isLoaded } = useAuth();

  const reload = useCallback(async () => {
    try {
      const r = await axios.get(`${API}/public/info`);
      setInfo(r.data);
      setError(false);
    } catch {
      setError(true);
    }
  }, []);

  const reloadMe = useCallback(async () => {
    if (!isSignedIn) {
      setMe(null);
      return setMeStatus("idle");
    }
    setMeStatus("loading");
    try {
      const t = await getToken();
      const r = await axios.get(`${API}/me`, { headers: { Authorization: `Bearer ${t}` } });
      setMe(r.data);
      setMeStatus("ready");
    } catch {
      setMe(null);
      setMeStatus("error");
    }
  }, [isSignedIn, getToken]);

  useEffect(() => {
    reload();
  }, [reload]);

  useEffect(() => {
    if (isLoaded) {
      reloadMe();
    }
  }, [isLoaded, reloadMe]);

  return (
    <InfoCtx.Provider value={{ info, error, reload, me, meStatus, reloadMe }}>{children}</InfoCtx.Provider>
  );
}

export const useInfo = () => useContext(InfoCtx);
